import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-social-media',
  templateUrl: './social-media.component.html',
  styleUrls: ['./social-media.component.less']
})
export class SocialMediaComponent implements OnInit {  // scrollIntoView: any;
  // renderer: any;
  // elementRef: any;
  constructor(private router: Router) {


  }

  ngOnInit() {

  }
  canceltoggleEmp() {
    localStorage.setItem("tab_value", "0");
    this.router.navigate(['/service']);
  }
  canceltoggleEmp1() {
    localStorage.setItem("tab_value", "4");
    this.router.navigate(['/service']);

  }


}
